module.exports = __webpack_public_path__ + "c24d85b3304897fcf6c5a0a2d4d3522d.png";